import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import infoIcon from '../../constants/icons/info_icon.png';
import arrowUpIcon from '../../constants/icons/arrow_up_icon.png';
import arrowDownIcon from '../../constants/icons/arrow_down_icon.png';

const DBetGameInfoCard = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card">
      <div className="cardTitle">
        <img src={infoIcon} alt="infoIcon" className="gameInfoIcon" />
        Game Info
      </div>
      <AnimatePresence key="gameInfoButton" exitBeforeEnter>
        {!isOpen ? (
          <motion.button
            key="arrowDownButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowDownIcon}
              alt="arrowDownIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        ) : (
          <motion.button
            key="arrowUpButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowUpIcon}
              alt="arrowUpIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        )}
      </AnimatePresence>
      <motion.div
        key="gameInfoCard"
        initial="collapsed"
        animate={isOpen ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: {
            height: '440px',
            transition: {
              delayChildren: 0.6,
              staggerChildren: 0.6,
              duration: 1.2,
              ease: 'easeInOut'
            }
          },
          collapsed: {
            height: '0px'
          }
        }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      >
        {isOpen && (
          <>
            <motion.div
              key="gameInfoHowToPlay"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="innerCard"
            >
              <div className="innerCardTitle">How to Play</div>
              <ol className="gameInfoCardBody">
                <li>
                  Download <a href="https://metamask.io/">MetaMask</a> digital
                  wallet and press login.
                </li>
                <li>Use arrows to browse between rooms.</li>
                <li>Press start if you want to start a new roll.</li>
                <li>Bet the value you want for an initiated roll.</li>
                <li>Existing bets adjusts return rates dynamically.</li>
                <li>Wait for the dice to roll.</li>
                <li>Press collect to claim the prize.</li>
              </ol>
            </motion.div>
            <motion.div
              key="gameInfoRules"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="innerCard"
            >
              <div className="innerCardTitle">Rules</div>
              <ul className="gameInfoCardBody">
                <li>Every game is an anonymous smart contract.</li>
                <li>There is no limit on the number of players.</li>
                <li>Every bet is accumulated in the prize pool.</li>
                <li>Return rate formula: prize_pool / total_bets_on_value_i</li>
                <li>
                  The return rates are calculated dynamically and updated after
                  each bet.
                </li>
                <li>Final return rates are settled in roll time.</li>
                <li>The prize is linearly distributed among winning bets.</li>
                <li>
                  Prizes are distributed to all players on collect action.
                </li>
              </ul>
            </motion.div>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default DBetGameInfoCard;
